// Network-related constants
export const DEFAULT_IP_API_URL = "https://api.ipify.org?format=json";
